export default{ // 运行在 评估师APP-复检工单列表-检测报告
  tabs: [
    {
      name: 'VehicleCondition',
      path: '/vehicleCondition',
      component: () => import('./src/VehicleCondition'),
      meta: {
        title: '车况说明'
      }
    }
  ]
}
